import React from "react";
import { Table } from "reactstrap";
import InfiniteScroll from "react-infinite-scroller";
import style from "./style.module.scss";
import CircularProgress from "./../CircularProgress/CircularProgress";
import * as UI from "./UI";
import { FormattedDate, FormattedTime } from "react-intl";
import { localDateTime } from "../../utils/Helper";
import { Tooltip } from "../UI";

const Grid = ({ authorizations, username, actions, loading, loadingAdvanced, loadMore, hasMore }) => {
  const view = (authorization) => {
    actions.toggleModal("modalAuth", { authorization });
    if (!authorization.wasReadBy.includes(username)) {
      actions.setRead(authorization);
    }
  };

  const getStatusPriority = (status) => {
    switch (status) {
      case "Waiting":
        return 0;
      case "Authorized":
        return 1;
      case "Rejected":
        return 2;
      default:
        return 3;
    }
  };
  

  return (
    <div className={style.grid}>
      <InfiniteScroll
        pageStart={0}
        loadMore={loadMore}
        hasMore={!loading && hasMore}
        loader={<CircularProgress key={0} />}
      >
        <Table striped hover>
          <thead>
            <tr>
              <th>Process</th>
              <th></th>
              <th>Title</th>
              <th>Status</th>
              <th>Auth. Role</th>
              <th>Requested By</th>
              <th>Processed By</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {authorizations == null || authorizations.length === 0 || loadingAdvanced ? (
              <EmptyTable loading={loading} loadingAdvanced={loadingAdvanced}/>
            ) : (
              authorizations
                .sort((a, b) => {
                  const statusPriorityA = getStatusPriority(a.status);
                  const statusPriorityB = getStatusPriority(b.status);

                  if (statusPriorityA !== statusPriorityB) {
                    return statusPriorityA - statusPriorityB;
                  }
                  return new Date(b.dateTime) - new Date(a.dateTime);
                })
                .map((a, index) => (
                  <tr key={`auth-${a.id}-${index}`} onClick={() => view(a)}>
                    <td>
                      <strong>{a.process}</strong>
                    </td>
                    <td>
                      <UI.ReadStatus status={a.status} wasRead={a.wasReadBy.includes(username)} />
                    </td>
                    <td>
                      {a.title} {a.hasPendingRelatedAuthorizations ? <PendingRelatedAuthorizations /> : null}
                    </td>
                    <td>
                      <UI.Status status={a.status} />
                    </td>
                    <td>{a.role}</td>
                    <td>{a.requestedBy}</td>
                    <td>{a.processedBy}</td>
                    <td>
                      <FormattedDate value={localDateTime(a.dateTime)} />{" "}
                      <FormattedTime value={localDateTime(a.dateTime)} hour12={false} />
                    </td>
                  </tr>
                ))
            )}
          </tbody>
        </Table>
      </InfiniteScroll>
    </div>
  );
};

const PendingRelatedAuthorizations = () => (
  <Tooltip text="This authorization has pending related authorizations">
    <i className="fa fa-exclamation-circle" aria-hidden="true" />
  </Tooltip>
);

const EmptyTable = ({ loading, loadingAdvanced }) => (
  <tr className={style.empty}>
    <td colSpan="10" style={{ textAlign: "center", padding: "60px" }}>
      {loading || loadingAdvanced ? <CircularProgress style={{ marginTop: "10%" }} /> : <h4>No Authorizations</h4>}
    </td>
  </tr>
);

export default Grid;